import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageOptimizerService {

  constructor() { }

  private getNetworkQuality(): number {
    const nav = navigator as any;
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;

    if (connection?.effectiveType) {
      switch (connection.effectiveType) {
        case 'slow-2g':
          return 10;
        case '2g':
          return 30;
        case '3g':
          return 50;
        case '4g':
          return 75;
        default:
          return 85;
      }
    }

    return 80;
  }

  getOptimizedImageUrl(basePath: string, width: number, quality?: number): string {
    const cleanedPath = basePath.replace(/^https?:\/\/[^\/]+/, '');
    const finalQuality = quality ?? this.getNetworkQuality();
    return `https://static.monific.com/cdn-cgi/image/width=${width},quality=${finalQuality}${cleanedPath}`;
  }

  getSrcSet(basePath: string): string {
    const quality = this.getNetworkQuality();
    return `
      https://static.monific.com/cdn-cgi/image/width=400,quality=${quality}/${basePath} 400w,
      https://static.monific.com/cdn-cgi/image/width=800,quality=${quality}/${basePath} 800w,
      https://static.monific..com/cdn-cgi/image/width=1200,quality=${quality}/${basePath} 1200w
    `;
  }

}
